import React from 'react';
import Box from './Box';

function Rengla({ 
    tronc,
    pomsStatus,
    renglaNum,
    rengla,
    castellersInfo,
    selectBox,
    selectedBox,
    assistencies,
    hores,
    bundleJSON,
    allFustes,
    lastPair
}) {
    // Group elements by type
    const noms = rengla
        .filter(([tipus, nom]) => tipus === 'nom')
        .map(([tipus, nom]) => nom);

    const fustes = rengla
        .filter(([fusta, altura]) => fusta === 'fusta');

    const fustesAltura = fustes
        .map(([fusta, altura]) => altura)
        .reduce((a, b) => a + b, 0);

    const cumSumFustes = fustes
        .map((altura, i) => fustes
            .map(([fusta, altura]) => altura)
            .slice(0, i + 1)
            .reduce((a, b) => a + b, 0)
        );

    const caixes = rengla
        .filter(([caixa, casteller]) => caixa !== 'fusta' && caixa !== 'nom')
        .filter(([caixa, casteller]) => bundleJSON?.[caixa]?.pom === undefined);

    const pomsRaw = rengla
        .filter(([caixa, casteller]) => caixa !== 'fusta' && caixa !== 'nom')
        .filter(([caixa, casteller]) => bundleJSON?.[caixa]?.pom !== undefined);

    // Get poms in specific order: enxaneta, acotxador, dos
    const pomOrder = ['enxaneta', 'acotxador', 'dos'];
    const poms = pomOrder
        .filter(pomType => pomsStatus[pomType])
        .map(pomType => pomsRaw.find(([caixa]) => bundleJSON?.[caixa]?.pom === pomType));

    // Calculate heights
    const altures = caixes
        .map(([caixa, casteller]) => castellersInfo[casteller] ? castellersInfo[casteller] : null)
        .map(casteller => casteller !== null ? casteller : null)
        .map(casteller => casteller?.altura ? casteller.altura : 0);

    const alturesPoms = poms
        .map(data => data?.[1] && castellersInfo[data?.[1]] ? castellersInfo[data?.[1]] : null)
        .map(casteller => casteller !== null ? casteller : null)
        .map(casteller => casteller?.altura ? casteller.altura : 0);

    const cumSumAltures = altures
        .map((altura, i) => altures
            .slice(0, i + 1)
            .reduce((a, b) => a + b, fustesAltura)
        );

    const cumSumAlturesPoms = alturesPoms
        .map((altura, i) => alturesPoms
            .slice(0, i + 1)
            .reduce((a, b) => a + b, cumSumAltures[caixes.length - 1])
        );

    const renderPom = (pomType) => {
        const pomData = poms.find(data => data && bundleJSON?.[data[0]]?.pom === pomType);
        if (!pomData) return null;

        if (bundleJSON?.[pomData[0]]?.clone) {
            const cloneCasteller = tronc
                .map(rengla => rengla.filter(([caixa, casteller]) => caixa !== 'fusta' && caixa !== 'nom'))
                .flat()
                .filter(([caixa, casteller]) => casteller)
                .map(([caixa, casteller]) => [caixa.split('_')[1], casteller])
                .find(([caixa, casteller]) => caixa === bundleJSON?.[pomData[0]]?.clone)
                ?.[1];

            return (
                <Box
                    isPom={true}
                    pomType={pomType}
                    caixa={pomData[0]}
                    casteller={cloneCasteller || null}
                    selectBox={selectBox(pomData[0])}
                    isClone={true}
                    castellersInfo={castellersInfo}
                    sumaAltures={cumSumAlturesPoms[poms.indexOf(pomData)]}
                    assistencia={(() => {
                        if (!cloneCasteller) return null;
                        const found = assistencies?.find(a => {
                            return a.user === parseInt(cloneCasteller);
                        });
                        return found || null;
                    })()}
                    lastPair={lastPair}
                    hores={hores}
                    bundleJSON={bundleJSON}
                    selectedBox={selectedBox}
                />
            );
        }

        return (
            <Box
                isPom={true}
                pomType={pomType}
                caixa={pomData[0]}
                casteller={pomData[1]}
                selectBox={selectBox(pomData[0])}
                isClone={false}
                castellersInfo={castellersInfo}
                sumaAltures={cumSumAlturesPoms[poms.indexOf(pomData)]}
                assistencia={(() => {
                    if (!pomData[1]) return null;
                    const found = assistencies?.find(a => {
                        return a.user === parseInt(pomData[1]);
                    });
                    return found || null;
                })()}
                lastPair={lastPair}
                hores={hores}
                bundleJSON={bundleJSON}
                selectedBox={selectedBox}
            />
        );
    };

    return (
        <div className="rengla">
            <div className="positions-container">
                {/* Poms at the top, each in its own row */}
                {pomsStatus.enxaneta && (
                    <div className="pom-row">
                        {renderPom('enxaneta')}
                    </div>
                )}
                {pomsStatus.acotxador && (
                    <div className="pom-row">
                        {renderPom('acotxador')}
                    </div>
                )}
                {pomsStatus.dos && (
                    <div className="pom-row">
                        {renderPom('dos')}
                    </div>
                )}

                {/* Regular positions */}
                <div className="regular-positions">
                    {[...caixes].reverse().map(([caixa, casteller], k) => {
                        const hasClone = bundleJSON?.[caixa]?.clone;
                        const cloneCasteller = hasClone ?
                            tronc
                                .map(rengla => rengla.filter(([caixa, casteller]) => caixa !== 'fusta' && caixa !== 'nom'))
                                .flat()
                                .filter(([caixa, casteller]) => casteller)
                                .map(([caixa, casteller]) => [caixa.split('_')[1], casteller])
                                .find(([caixa, casteller]) => caixa === bundleJSON?.[caixa]?.clone)
                                ?.[1] :
                            null;

                        const finalCasteller = hasClone ? (cloneCasteller || null) : casteller;

                        return (
                            <Box
                                key={caixa}
                                caixa={caixa}
                                casteller={finalCasteller}
                                selectBox={selectBox(caixa)}
                                isClone={!!hasClone}
                                castellersInfo={castellersInfo}
                                sumaAltures={cumSumAltures[caixes.length - 1 - k]}
                                assistencia={(() => {
                                    if (!finalCasteller) return null;
                                    const found = assistencies?.find(a => {
                                        return a.user === parseInt(finalCasteller);
                                    });
                                    return found || null;
                                })()}
                                lastPair={lastPair}
                                hores={hores}
                                bundleJSON={bundleJSON}
                                selectedBox={selectedBox}
                            />
                        );
                    })}
                </div>
            </div>

            {/* Fustes row */}
            <div className="fustes-row">
                {fustes.map(([fusta, altura], k) => (
                    <div
                        key={`fusta${k}`}
                        className={`fusta ${altura > 0 ? 'visible' : 'hidden'}`}
                    >
                        {altura > 0 ? altura : ''}
                    </div>
                ))}
            </div>

            {/* Column names at the bottom */}
            {noms.map((nom, k) => (
                <div
                    key={`nom${k}`}
                    className="nom-columna"
                >
                    {nom}
                </div>
            ))}

            <style jsx>{`
                .rengla {
                    display: flex;
                    flex-direction: column;
                    padding: 0.5rem;
                    min-width: 70px;
                    height: 100%;
                    justify-content: flex-end;
                }

                .positions-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 6px;
                }

                .pom-row {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    height: 35px;
                }

                .regular-positions {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 6px;
                    margin-top: 8px;
                }

                .fustes-row {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    margin-bottom: 6px;
                }

                .fusta {
                    width: 65px;
                    height: 25px;
                    padding: 3px 0;
                    background-color: #8B4513;
                    border-radius: 4px;
                    margin: 3px auto;
                    position: relative;
                    border: 2px solid transparent;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 11px;
                    transition: all 0.2s;
                }

                .fusta.hidden {
                    visibility: hidden;
                }

                .fusta:hover {
                    background-color: #A0522D;
                }

                .nom-columna {
                    height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.75rem;
                    color: #666;
                    font-weight: bold;
                    overflow: hidden;
                    margin: 3px 0;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height: 1.2;
                    text-align: center;
                }
            `}</style>
        </div>
    );
}

export default Rengla; 